export const state = () => ({
	isPaused: false,
});

export const mutations = {
	setPause(state, val) {
		state.isPaused = val;
	},
};
